import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { WebsiteLink } from 'client/components/core/Sidebar/components/Settings/components/website-link'

interface LinkSourceWebsiteProps {
  link: string | null
  update: (url: string) => void
}

export const LinkSourceWebsite = ({ link, update }: LinkSourceWebsiteProps) => {
  const { t } = useTypedTranslation()

  return (
    <div className="flex items-center justify-between px-6 py-3">
      <label htmlFor="website-link-input" className="block text-heading-5">
        {t('components.core.text_editor.link_toolbar.website_link')}
      </label>
      <WebsiteLink className="w-2/3 text-left" update={update} link={link} />
    </div>
  )
}
